import { render, staticRenderFns } from "./template_pick.vue?vue&type=template&id=7182bf9f&scoped=true"
import script from "./template_pick.vue?vue&type=script&lang=js"
export * from "./template_pick.vue?vue&type=script&lang=js"
import style0 from "./template_pick.vue?vue&type=style&index=0&id=7182bf9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7182bf9f",
  null
  
)

export default component.exports